import React from "react";
import Joi from "joi-browser";
import Form from "../common/form/form";
import { getMatch, saveMatch, getMatches } from "./../../services/matchService";
import { getLeagues } from "./../../services/leagueService";
import { getSeasons } from "./../../services/seasonService";
import { getMatchDays } from "./../../services/matchDayService";
import { getTeams } from "./../../services/teamService";
import _ from "lodash";

class MatchForm extends Form {
  state = {
    data: {
      id: -1,
      league: -1,
      season: -1,
      matchDay: -1,
      dateTime: new Date(),
      teamHome: -1,
      teamAway: -1,
      scoreHome: 0,
      scoreAway: 0,
      isFinished: false,
      addInf: ""
    },
    leagues: [],
    seasons: [],
    matchDays: [],
    teams: [],
    errors: {}
  };

  schema = {
    id: Joi.number(),
    league: Joi.number(),
    season: Joi.number(),
    matchDay: Joi.number(),
    dateTime: Joi.date(),
    teamHome: Joi.number(),
    teamAway: Joi.number(),
    scoreHome: Joi.number(),
    scoreAway: Joi.number(),
    isFinished: Joi.boolean(),
    addInf: Joi.string().allow("")
  };

  async componentDidMount() {
    const { match: propMatch, history } = this.props;

    this.setState({
      leagues: _.orderBy(await getLeagues(), "name"),
      seasons: _.orderBy(await getSeasons(), "name"),
      matchDays: _.orderBy(await getMatchDays(), "name"),
      teams: _.orderBy(await getTeams(), "name")
    });

    const matchId = propMatch.params.id;
    if (matchId === "new") {
      const matches = await getMatches();
      this.setState({ data: this.setDefaultValues(matches[0]) });
      return;
    }

    const match = await getMatch(matchId);
    if (!match) return history.replace("/not-found");

    this.setState({ data: this.mapToViewModel(match) });
  }

  setDefaultValues(match) {
    return {
      id: -1,
      league: match.league.id,
      season: match.season.id,
      matchDay: match.matchDay.id,
      dateTime: match.dateTime,
      teamHome: -1,
      teamAway: -1,
      scoreHome: 0,
      scoreAway: 0,
      isFinished: false,
      addInf: ""
    };
  }

  mapToViewModel(match) {
    return {
      id: match.id,
      league: match.league.id,
      season: match.season.id,
      matchDay: match.matchDay.id,
      dateTime: match.dateTime,
      teamHome: match.teamHome.id,
      teamAway: match.teamAway.id,
      scoreHome: match.scoreHome.toString(),
      scoreAway: match.scoreAway.toString(),
      isFinished: match.isFinished,
      addInf: match.addInf || ""
    };
  }

  doSubmit = async () => {
    await saveMatch(this.state.data);
    this.props.history.push("/matches");
  };

  render() {
    const { leagues, seasons, matchDays, teams } = this.state;

    return (
      <div>
        <h2>Match</h2>
        <form onSubmit={this.handleSubmit}>
          {this.renderLink("/matches", "fa fa-arrow-left", "btn btn-secondary")}
          {this.renderButton("fa fa-save", "btn btn-success m-1")}
          {this.renderSelect("league", "League", leagues, false)}
          {this.renderSelect("season", "Season", seasons, false)}
          {this.renderSelect("matchDay", "Match day", matchDays, false)}
          {this.renderInput("dateTime", "Date/Time")}
          {this.renderSelect("teamHome", "Home team", teams, true)}
          {this.renderSelect("teamAway", "Away team", teams, true)}
          {this.renderInput("scoreHome", "Score home")}
          {this.renderInput("scoreAway", "Score away")}
          {this.renderCheckBox("isFinished", "Finished")}
          {this.renderInput("addInf", "Add. Inf.")}
        </form>
      </div>
    );
  }
}

export default MatchForm;



// WEBPACK FOOTER //
// ./src/components/matches/matchForm.jsx